export const scrollToTop = () => {
  const element = document.getElementById("document-content")

  if (element) {
    element.scrollTo({
      top: 0,
    })
  }
}